module.exports = __webpack_public_path__ + "static/media/pdf-background.e8204f39.jpg";